export default function Sidebar() {
    return (
        <aside className="col-12 col-md-12 col-xl-3">
            <div className="sidebar box-outer sticky-column">
                <div className="sidebar__base-info">
                    {/* <figure className="avatar-box">
                        <img src="/assets/images/tin.jpg" alt="Tin Pham" />
                    </figure> */}
                    <div className="text-xl-center">
                        <h2 className="title title--h3 sidebar__name">Tin Pham</h2>
                        <div className="badge">Senior Software Engineer</div>
                    </div>

                    <button className="btn btn--small btn--icon-right sidebar__btn js-btn-toggle"><span>Show Contacts</span><i className="feathericon-chevron-down"></i></button>
                </div>

                <div className="sidebar__additional-info js-show">
                    <div className="separation"></div>
                    <ul className="details-info">
                        <li className="details-info__item">
                            <span className="box icon-box"><i className="font-icon icon-envelope"></i></span>
                            <div className="contacts-block__info">
                                <span className="overhead">Email</span>
                                <a className="text-overflow" href="mailto:independent.bitstar@gmail.com" title="independent.bitstar@gmail.com">independent.bitstar@gmail.com</a>
                            </div>
                        </li>
                         <li className="details-info__item">
                            <span className="box icon-box"><i className="font-icon icon-phone"></i></span>
                            <div className="contacts-block__info">
                                <span className="overhead">Phone</span>
                                <span className="text-overflow" title="+1 (760) 884-2275">+1 (760) 884-2275</span>
                            </div>	
                        </li>
                        <li className="details-info__item">
                            <span className="box icon-box"><i className="font-icon icon-skype"></i></span>
                            <div className="contacts-block__info">
                                <span className="overhead">Skype</span>
                                <a className="text-overflow" target="blank" href="https://join.skype.com/invite/nwvalPzajpP3" title="live:.cid.a6956014d13187fe">live:.cid.a6956014d13187fe</a>
                            </div>	
                        </li>
                        <li className="details-info__item">
                            <span className="box icon-box"><i className="font-icon feathericon-linkedin"></i></span>
                            <div className="contacts-block__info">
                                <span className="overhead">LinkedIn</span>
                                <a className="text-overflow" target="blank" href="https://www.linkedin.com/in/tin-pham-6b9711248/" title="LinkedIn">https://www.linkedin.com/in/tin-pham-6b9711248/</a>
                            </div>
                        </li>
                        <li className="details-info__item">
                            <span className="box icon-box"><i className="font-icon icon-github"></i></span>
                            <div className="contacts-block__info">
                                <span className="overhead">Github</span>
                                <a className="text-overflow" target="blank" href="https://github.com/BitstarGit" title="Github">https://github.com/BitstarGit</a>
                            </div>
                        </li>
                        <li className="details-info__item">
                            <span className="box icon-box"><i className="font-icon icon-location"></i></span>
                            <div className="contacts-block__info">
                                <span className="overhead">Location</span>
                                <span className="text-overflow" title="Escondido, USA">Escondido,United States</span>
                            </div>
                        </li>
                    </ul>
                    <div className="separation d-xl-none"></div>
                </div>	
            </div>	
        </aside>
    )
}